import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  background: transparent;
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;
  z-index: 12;
  font-family: "Monsieur La Doulaise", cursive;
  font-weight: 400;
  font-style: normal;
  font-size: 3vmin;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;

  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 0 1rem;
  }
`;

export const HomeIcon = styled.img`
  display: none;
  height: 40px;
  width: auto;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const NavLink = styled(Link)`
  display: flex;
  color: #191919;
  align-items: center;
  text-decoration: none;
  height: 100%;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease-in-out;
  border-radius: 4px;
  flex: 1;
  justify-content: center;
  text-align: center;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: auto;
    padding: 1.5rem;
    font-size: 2rem;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  max-width: 800px;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: 0;
    width: 70%;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    background: rgba(245, 233, 221, 0.98);
    transform: ${({ isOpen }) =>
      isOpen ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.3s ease-in-out;
    z-index: 99;
    box-shadow: ${({ isOpen }) =>
      isOpen ? "-5px 0 15px rgba(0, 0, 0, 0.1)" : "none"};
  }
`;

export const HamburgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 101;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 2rem;
    height: 1.5rem;
    transform: ${({ isOpen }) => (isOpen ? "rotate(90deg)" : "rotate(0)")};
    transition: transform 0.3s ease-in-out;
  }

  span {
    width: 4px;
    height: 4px;
    background: #191919;
    border-radius: 50%;
    transition: all 0.3s ease-in-out;

    &:nth-child(1) {
      transform: ${({ isOpen }) =>
        isOpen ? "translateX(4px)" : "translateX(0)"};
      opacity: ${({ isOpen }) => (isOpen ? "0" : "1")};
    }

    &:nth-child(3) {
      transform: ${({ isOpen }) =>
        isOpen ? "translateX(-4px)" : "translateX(0)"};
      opacity: ${({ isOpen }) => (isOpen ? "0" : "1")};
    }
  }
`;

export const Overlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    z-index: 98;
  }
`;
